module.exports = __webpack_public_path__ + "media/Gosser_Spritz_6_Sec_V2.4b584ed6.mp4";